import React from 'react';
import companyStyles from './Company.module.css';
import background from '../../../assets/img/company-background.png';
import { SectionHeader } from '../../SectionHeader/SectionHeader';
import CompanyBenefit from '../../CompanyBenefit/CompanyBenefit';

export function Company() {
  return (
    <section className={companyStyles.company} style={{ backgroundImage: `url(${background})` }} id="empresa">
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <SectionHeader title='section:company:title' subtitle='section:company:subtitle'></SectionHeader>
        <CompanyBenefit.Group>
          <CompanyBenefit label='section:company:benefits:1' />
          <CompanyBenefit label='section:company:benefits:2' />
          <CompanyBenefit label='section:company:benefits:3' />
          <CompanyBenefit label='section:company:benefits:4' />
        </CompanyBenefit.Group>
      </div>
    </section>
  );
}
